import Typography from "@material-ui/core/Typography";

const DriverWithPhoneField = ({ record }: any) => {
  if (record !== null) {
    return (
      <Typography variant="body2">{`${record?.fullName} - ${record?.contactNumber}`}</Typography>
    );
  }
  return <Typography variant="body2">loading...</Typography>;
};

export default DriverWithPhoneField;
